import React, { Component } from 'react';
import ErrorScreen from '../../../screens/ErrorScreen/ErrorScreen';
import {
  serverErrorText,
} from '../../../constants/textConstants';
import picsLibrary from '../../../constants/picsLibrary';

class Stopper extends Component {

  componentDidMount = () => {
  }

  render() {
    const { handlingCode } = this.props;
    if (!handlingCode) {
      // fake...
      return null;
    }

    return (
      <div className="Stopper">
        { handlingCode === -1 && (
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-sm-12">
                <ErrorScreen
                  errorTitle={serverErrorText.errorTitle1}
                  errorImage={picsLibrary.error}
                  errorAlt={serverErrorText.errorAlt1}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Stopper;
